module.exports = __webpack_public_path__ + "static/media/Floor_After.5790b61b.jpg";